import _objectSpread from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _classCallCheck from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import { PingManager } from './PingManager';
import { CaretManager } from './CaretManager';
import { MarkerEvent } from './MarkerEvent';

var debug = require('debug')('CRATE:Communication:MarkerManager:MarkerManager');
/**
 * This class manages markers,pings,cursors of the different users
 */


export var MarkerManager =
/*#__PURE__*/
function (_MarkerEvent) {
  _inherits(MarkerManager, _MarkerEvent);

  function MarkerManager(opts) {
    var _this;

    _classCallCheck(this, MarkerManager);

    var EventName = opts.EventName || 'MarkerManager';
    _this = _possibleConstructorReturn(this, _getPrototypeOf(MarkerManager).call(this, _objectSpread({
      EventName: EventName
    }, opts)));
    _this._pingManager = new PingManager(_objectSpread({}, opts));
    _this._caretManger = new CaretManager(_objectSpread({}, opts));

    _this._pingManager.on("Ping_received", function (msg) {
      _this.emit("Ping_received", msg);
    });

    _this._caretManger.on("Caret_received", function (msg) {
      _this.emit("Caret_received", msg);

      debug("Caret_received", msg);
    });

    return _this;
  }
  /**
   * Set the current caret position
   * @param {*} range the current caret position 
   */


  _createClass(MarkerManager, [{
    key: "caretMoved",
    value: function caretMoved(range) {
      this._caretManger.caretMoved(range);
    }
  }, {
    key: "close",
    value: function close() {
      this._pingManager.close();

      this._caretManger.close();
    }
  }]);

  return MarkerManager;
}(MarkerEvent);